import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Gauge, AlertTriangle, Undo2 } from "lucide-react";
import { http } from "../../lib/api";
import { fmtTL } from "../../lib/format";

// Kredi formu: Firma + Banka + Kredi Türü seçilince ilgili Limit Risk satırının kalan limiti canlı gösterilir;
// girilen tutar (düzenlemede artış) kalanı aşarsa kırmızı uyarı → Kaydet kapatılır (arka uç de reddeder)
export default function LoanLimitHint({ company, bank, loanType, delta, skip, onCapacity }) {
  const [cap, setCap] = useState(null);
  useEffect(() => {
    if (!company || !bank || !loanType) { setCap(null); onCapacity?.(null); return; }
    let on = true;
    http.get("/limit-risk/capacity", { params: { company, bank, loan_type: loanType } })
      .then((r) => { if (on) { setCap(r.data); onCapacity?.(r.data); } })
      .catch(() => { if (on) { setCap(null); onCapacity?.(null); } });
    return () => { on = false; };
  }, [company, bank, loanType]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!cap || skip) return null;
  const over = delta > 0 && delta > cap.remaining;
  const tone = over ? "border-red-300 bg-red-50 text-red-800" : !cap.exists ? "border-amber-300 bg-amber-50 text-amber-800" : "border-emerald-300 bg-emerald-50 text-emerald-800";
  return (
    <div className={`col-span-2 md:col-span-4 rounded-md border px-3 py-2 text-xs flex items-center gap-2 flex-wrap ${tone}`} data-testid="loan-limit-hint">
      {over ? <AlertTriangle className="w-4 h-4 shrink-0" /> : <Gauge className="w-4 h-4 shrink-0" />}
      <span className="font-semibold">{cap.row}</span>
      {!cap.exists
        ? <span data-testid="loan-limit-nocard">— bu firma/banka için Limit Risk kartı yok: kalan limit 0,00 TL, kaydedilemez.</span>
        : <span>kalan limit <b data-testid="loan-limit-remaining">{fmtTL(cap.remaining)}</b> <span className="opacity-80">(limit {fmtTL(cap.limit)} · risk {fmtTL(cap.risk)})</span></span>}
      {cap.returned_count > 0 && <span className="inline-flex items-center gap-1 opacity-90" data-testid="loan-limit-returned"><Undo2 className="w-3 h-3" /> iade edilen {cap.returned_count} mektup ({fmtTL(cap.returned_total)}) kullanılabilir limite eklendi</span>}
      {over && <span className="font-bold" data-testid="loan-limit-over">Limit aşımı: girilen {fmtTL(delta)} &gt; kalan {fmtTL(Math.max(cap.remaining, 0))} — Bu bankada bu kredi türü için bu kadar limitiniz yok. Lütfen limitleri güncelleyiniz.</span>}
      <Link to={`/veri-girisi?bolum=kredi&alt=limit${cap.card_id ? `&kayit=${cap.card_id}` : ""}`} className="ml-auto underline font-semibold whitespace-nowrap" data-testid="loan-limit-link">Limit Risk'e git</Link>
    </div>
  );
}
